<template>
    <aside>
        <p>
            <sup v-for="tag in checklist.tags" :style="{backgroundColor: tag.color}">{{tag.name}}</sup>
        </p>
        <h3>{{checklist.title}}</h3>
        <p>{{checklist.description}}</p>
        <hr>
        <router-link :to="{name: 'ChecklistDetail', params: {id:checklist.id, slug:checklist.slug}}">Go to list &rarr;</router-link>
    </aside>
</template>

<script>

export default {
  name: 'ChecklistItem',
  props: [
      'checklist',
  ]
}
</script>
